import AntCheckbox from 'antd/lib/checkbox';

export const Checkbox = AntCheckbox;
